import { Button, Input, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import classnames from 'classnames'
import React from 'react'
import { Mutation } from 'react-apollo'
import { removeTypename } from '../../../common/utils'
import { i18n } from '../../index'
import { positionOptions } from '../../staffingPlan/StaffingPlan'
import pageCss from '../incentiveProduct/incentiveProductPage.css'
import css from '../incentiveProduct/incentiveProductTable.css'
import { upsertActivityWeightsMutation } from './queries'

const objectifyWeightPercentages = (
  weightArray: {
    activity: string
    weightPercentage: number
  }[] = [],
): Record<string, number> => {
  return weightArray.reduce(
    (object, { activity, weightPercentage }) => ({
      ...object,
      [activity]: weightPercentage,
    }),
    {},
  )
}

export default class ActivityWeightsTable extends React.PureComponent<any, any> {
  state = {
    editable: removeTypename(objectifyWeightPercentages(this.props.data)),
    upstream: removeTypename(objectifyWeightPercentages(this.props.data)),
    editing: !this.props.data.length,
  }
  handleWeightPercentageChange = (key: any, value: any) => {
    const editableState = this.state.editable
    this.setState({
      editable: { ...editableState, [key]: parseFloat(value || 0) },
    })
  }
  handleSubmit = (mutate: any) => async () => {
    if (!this.state.editing) {
      return this.setState({
        editing: true,
      })
    }

    const editableStateAsArray = Object.entries(this.state.editable).map(([activity, weightPercentage]) => ({
      activity,
      weightPercentage,
    }))
    const {
      data: { upsertActivityWeights: updatedData },
    } = await mutate({
      variables: {
        stationId: this.props.stationId,
        data: editableStateAsArray,
        type: this.props.type,
      },
    })
    return this.setState({
      editing: false,
      editable: removeTypename(objectifyWeightPercentages(updatedData)),
      upstream: removeTypename(objectifyWeightPercentages(updatedData)),
    })
  }
  handleCancel = () => {
    return this.setState({
      editing: false,
    })
  }

  render() {
    const { editable, upstream, editing } = this.state
    const editableTotalPercentage = Object.values(editable).reduce(
      (totalPercentage, current) => totalPercentage + current,
      0,
    )
    const upstreamTotalPercentage = Object.values(upstream).reduce(
      (totalPercentage, current) => totalPercentage + current,
      0,
    )
    const totalPercentage = editing ? editableTotalPercentage : upstreamTotalPercentage
    return (
      <React.Fragment>
        <h2>{i18n.t('admin.activityWeightsHeading')}</h2>
        <Paper>
          <div className={css.component}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={css.tableHeading}>{i18n.t('admin.activityWeights.activity')}</TableCell>
                  <TableCell className={css.tableHeading}>{i18n.t('admin.activityWeights.weight')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {positionOptions.map(({ label: positionLabel, value: positionValue }, i) => (
                  <TableRow key={i}>
                    <React.Fragment>
                      <TableCell className={css.tableCell}>
                        {i18n.t(`staffingPlan.positions.${positionLabel}`)}
                      </TableCell>
                      {editing ? (
                        <TableCell className={css.tableCell}>
                          <Input
                            type='number'
                            onChange={(e) => this.handleWeightPercentageChange(positionValue, e.target.value)}
                            value={editable[positionValue] || 0}
                          />
                        </TableCell>
                      ) : (
                        <TableCell key={i} className={css.tableCell}>
                          {upstream[positionValue]}
                        </TableCell>
                      )}
                    </React.Fragment>
                  </TableRow>
                ))}
                <TableRow>
                  <React.Fragment>
                    <TableCell className={css.tableCell}>{i18n.t('admin.activityWeights.total')}</TableCell>
                    <TableCell className={classnames(css.tableCell, totalPercentage > 100 ? css.red : css.green)}>
                      {totalPercentage} %
                    </TableCell>
                  </React.Fragment>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </Paper>
        <Mutation mutation={upsertActivityWeightsMutation}>
          {(mutate, { loading }) => (
            <div className={pageCss.bottom}>
              {editing && (
                <Button
                  style={{
                    marginRight: '10px',
                  }}
                  variant='contained'
                  color='secondary'
                  onClick={this.handleCancel}
                >
                  {i18n.t('buttons.cancel')}
                </Button>
              )}

              <Button
                variant='contained'
                disabled={loading || (editing && totalPercentage > 100)}
                color='primary'
                type='submit'
                onClick={this.handleSubmit(mutate)}
              >
                {loading ? 'Lataa...' : editing ? i18n.t('buttons.save') : i18n.t('buttons.edit')}
              </Button>
            </div>
          )}
        </Mutation>
      </React.Fragment>
    )
  }
}
